module.exports = __webpack_public_path__ + "img/img1-4.1b3d798b.png";